import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CustomSelect from '../../../Core/CustomSelect'
import Button from '../../../Core/Button/Button'
import EmployeeTargtesForm from '../EmployeeTargetsForm'

import styles from './styles.module.scss'

const EmployeeTargets = ({employees, onChangeEmployees, onSubmit}) => {
  const { t } = useTranslation()

  const selectedEmployees = employees.filter(emp => emp.checked)

  const handleChangeFilter = (field, value) => {
    onChangeEmployees(value)
  }

  const handleChangeForm = (employeeId, updatedFields) => {
    const updatedEmployees = employees.map(emp => {
      if (emp.id === employeeId) {
        return {
          ...emp,
          targets: {
            ...emp.targets,
            ...updatedFields
          }
        }
      }
      return emp
    })
    onChangeEmployees(updatedEmployees)
  }

  const handleSave = () => {
    if (onSubmit) {
      onSubmit()
    }
  }

  return (
    <div className={styles.container}>
      <CustomSelect
        placeholder={t('All employees')}
        items={employees}
        onChange={data => handleChangeFilter('employees', data)}
        width='auto' />
      <div className={styles.employeesFormsContainer}>
        {
          selectedEmployees.map((employee, i) => {
            return (
              <EmployeeTargtesForm
                key={employee.id}
                employee={employee}
                onChange={handleChangeForm} />
            )
          })
        }
      </div>
      <div className={styles.buttonContainer}>
        <Button
          primary
          onClick={handleSave}
          fillWidth
        >
          {t('Save')}
        </Button>
      </div>
    </div>
  )
}

export default EmployeeTargets
